<template>
  <div>
    <v-row>
      <v-col xs="12" md="6">
        <div class="headline">Neue Aufträge</div>
        <v-data-table
          :headers="tables.duties.header"
          :items="dutiesNew"
          :items-per-page="5"
          :footer-props="footerProps"
          class="mb-4"
          no-data-text="Keine neuen Aufträge vorhanden">
          <template v-slot:item.name="{ item }">
            {{ item.firstname }} {{ item.lastname }}
          </template>
          <template v-slot:item.address="{ item }">
            {{ getCityFromStreetId(item.street).name }} - {{ getDistrictFromStreetId(item.street).name }}<br>
            {{ getStreet(item.street).name }} {{ item.streetNumber }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn text icon :to="{ name: 'duty', params: { id: item.id }}">
              <v-icon>far fa-edit</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-btn color="primary" :to="{ name: 'duties' }">Alle Aufträge</v-btn>
        <v-btn color="green" :to="{name: 'duty_new'}">Grüne Karte erfassen</v-btn>
        <div class="headline mt-12">Warteliste</div>
        <v-data-table
          :headers="tables.duties.header"
          :items="dutiesWaiting"
          :items-per-page="5"
          no-data-text="Keine wartenden Aufträge vorhanden"
          no-results-text="Keine wartenden Aufträge vorhanden"
          :footer-props="footerProps">
          <template v-slot:item.name="{ item }">
            {{ item.firstname }} {{ item.lastname }}
          </template>
          <template v-slot:item.address="{ item }">
            {{ getCityFromStreetId(item.street).name }} - {{ getDistrictFromStreetId(item.street).name }}<br>
            {{ getStreet(item.street).name }} {{ item.streetNumber }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn text icon :to="{ name: 'duty', params: { id: item.id }}">
              <v-icon>far fa-edit</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col  xs="12" md="6">
        <div class="headline">Touren</div>
        <v-data-table :headers="tables.tour.header"
                      :items="upcomingTour"
                      :items-per-page="15"
                      :footer-props="footerProps"
                      class="mb-4">
          <template v-slot:item.number="{ item }">
            <TourID :tour="item"></TourID>
          </template>
          <template v-slot:item.namedCities="{ item }">
            <TourName :tour="item"></TourName>
          </template>
          <template v-slot:item.weight="{ item }">
            <TourWorkload :tour="item"></TourWorkload>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn text icon small :to="{name: 'duties', params: {id: item.id}}">
              <v-icon>far fa-clipboard-list</v-icon>
            </v-btn>
            <v-btn text icon small @click="downloadPdf(item.id)">
              <v-icon>far fa-file-pdf</v-icon>
            </v-btn>
            <v-btn text icon small @click="downloadMapPdf(item.id)">
              <v-icon>far fa-map</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-btn color="primary" :to="{ name: 'tour' }">Alle Touren</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '../api/api'
import TourName from './TourName'
import TourWorkload from './TourWorkload'
import TourID from './TourID'

const filters = {
  all: items => items.filter(item => item.deleted !== true),
  new: items => items.filter(item => item.tour === 0 && item.waitingList !== true && item.deleted !== true),
  waiting: items => items.filter(item => item.waitingList === true && item.deleted !== true)
}

export default {
  name: 'Dashboard',
  components: {TourID, TourWorkload, TourName},
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  computed:
      {
        allDuties () {
          return this.$store.state.duties.all
        },
        dutiesNew () {
          return filters['new'](this.$store.state.duties.all)
        },
        dutiesWaiting () {
          return filters['waiting'](this.$store.state.duties.all)
        },
        tour () {
          return this.$store.state.tour.all
        },
        upcomingTour () {
          return this.$store.state.tour.all.filter(item => {
            let date = new Date(item.dateEn)
            let today = new Date()
            today.setHours(0)
            today.setMinutes(0)
            if (date >= today) {
              return item
            }
          })
        }
      },
  data: () => ({
    tables: {
      duties: {
        header: [
          {text: 'Name', sortable: false, value: 'name'},
          {text: 'Anschrift', sortable: false, value: 'address'},
          {text: '', sortable: false, value: 'action'}
        ]
      },
      tour: {
        header: [
          {text: 'Datum', sortable: false, value: 'date'},
          {text: 'Nummer', sortable: false, value: 'number', align: 'center'},
          {text: 'Name', sortable: false, value: 'name'},
          {text: 'Auslastung', sortable: false, value: 'weight'},
          {text: '', sortable: false, value: 'action', width: 125}
        ]
      }
    },
    footerProps: {
      'disable-items-per-page': true
    }
  }),
  methods: {
    displayCity (id) {
      this.$store.state.cities.all.find(function (city) {
        if (city.id === id) {
          return city.name
        }
      })
    },
    displayStreet (id) {
      let street = ''
      this.$store.state.streets.all.find(function (item) {
        if (item.id === id) {
          street = item.name
        }
      })
      return street
    },
    getCity (id) {
      return this.$store.state.cities.all.find(element => element.id === id)
    },
    getDistrict (id) {
      return this.$store.state.districts.all.find(element => element.id === id)
    },
    getStreet (id) {
      const street = this.$store.state.streets.all.find(element => element.id === id)
      if (street !== undefined) {
        return this.$store.state.streets.all.find(element => element.id === id)
      }
      return {
        name: ''
      }
    },
    getCityFromStreetId (streetId) {
      const street = this.getStreet(streetId)
      if (street !== undefined) {
        const city = this.getCity(street.city)
        if (city !== undefined) {
          return city
        }
      }
      return {
        name: ''
      }
    },
    getDistrictFromStreetId (streetId) {
      const street = this.getStreet(streetId)
      if (street !== undefined) {
        const district = this.getDistrict(street.district)
        if (district !== undefined) {
          return district
        }
      }
      return {
        name: ''
      }
    },
    fetchData () {
      this.$store.dispatch('getAllDuties')
      this.$store.dispatch('getAllTour')
    },
    downloadPdf (id) {
      let tour = this.$store.state.tour.all.find(element => element.id === id)
      let filename = 'Tour ' + tour.template + ' - ' + tour.date + ' - Liste.pdf'
      api.downloadTourPdf(id, filename)
    },
    downloadMapPdf (id) {
      let tour = this.$store.state.tour.all.find(element => element.id === id)
      let filename = 'Tour ' + tour.template + ' - ' + tour.date + ' - Karte.pdf'
      api.downloadTourMapPdf(id, filename)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../scss/settings";

  .city {
    display: inline-block;
    padding-right: 0.75rem;
  }

  .status {
    height: 1rem;
    width: 1rem;
    display: inline-block;
    border-radius: 1rem;

    &.ok {
      background-color: green;
    }

    &.nearlyFull {
      background-color: orange;
    }

    &.full {
      background-color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue